import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { WithTooltip } from '../../design-system'
import { CsWarningIcon } from '../../legacy-design-system/icons'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import { Placement } from '../../legacy-design-system/popper'

export interface ServerInstrumentationTooltipProps {
  readonly serverName: string
  readonly placement?: Placement
  readonly size?: number
  readonly e2eTestId?: string
}

export function ServerInstrumentationTooltip({
  serverName,
  placement,
  size,
  e2eTestId
}: ServerInstrumentationTooltipProps) {
  return (
    <Fragment>
      <div
        data-e2e={e2eTestId}
        className={css`
          padding-right: 2px;
          margin-top: 3px;
        `}
      >
        <WithTooltip
          placement={placement}
          renderTooltipContent={() => (
            <ServerInstrumentationTooltipContent serverName={serverName} />
          )}
          tooltipMaxWidth="200px"
          fontSize={13}
          containerClassName={css`
            cursor: default;
          `}
          children={() => (
            <CsWarningIcon size={size} color={theme.color.red50} />
          )}
        />
      </div>
    </Fragment>
  )
}

export function ServerInstrumentationTooltipContent({
  serverName
}: ServerInstrumentationTooltipProps) {
  return (
    <span>
      <FormattedMessage
        id="variable_servers_instrumentation_conflict"
        values={{ serverName }}
      />
    </span>
  )
}
